<template>
        <div class="flex flex-col h-full w-full px-2">
            <h3>{{ CardTitle }}</h3>
            <card-form
                ref="cardRef"
                :meta="empCardMeta"
                :to-remove-toolbar-items-names="ToRemoveButtons"
                components-path="views/counteragents/counteragent-card/field-wrappers"
                :use-default-buttons="true"
                :default-handlers="{ refresh: null, commit: null }"
                :callbacks="{refreshData: refreshData, saveData: saveData, isDirty: null, getUserData: getUserData}"
            />
        </div>
</template>
<script setup>

//import {useRoute} from "vue-router";
import CardForm from '@/components/card-component/card-form.vue';
//const route = useRoute();
import { getNsiEmpCardData, saveNsiEmpCard } from '@/service/nsi-service';
import { ref } from 'vue';
const CardTitle = ref();
const cardRef = ref();

let v_pr_new = false;
let v_id = 0;
var v_parent_id = 0;


const refreshData = async () => {
    if ((!v_pr_new) && (v_id === 0)) {
        return;
    }
        const tmpSource = await getNsiEmpCardData(v_id, v_parent_id);
        if (tmpSource.data)
            CardTitle.value = tmpSource.data.path;
        return tmpSource;
}

const SetId = (id, parent_id) => {
    v_id = id;
    v_parent_id = parent_id;
    if (v_id === 0) v_pr_new = true;
}

const forceRefresh = () => {
    cardRef.value.onRefreshDataButtonClick();
}

defineExpose({SetId, forceRefresh});

const emit = defineEmits(['NewItemSaved']);

const saveData = async data => {
    const response = await saveNsiEmpCard(data);
    if ((response.result) && (response.success)) {
        if (response.kod_emp)
            v_id = response.kod_emp;
        emit('NewItemSaved', 'emp_' + v_id);
    }
    return response;
};

const getUserData = async() => {
    return { result: true, changes: [] };
}

const ToRemoveButtons = [
    'refresh',
    'copy',
    'edit',
    'delete'
];

const empCardMeta = {
    groups: [
        {
            id: 1,
            label: 'Основные реквизиты',
            collapsed: false,
        },
    ],
    components: [
        // GROUP 1

        {
            fieldType: 'ai-form-text-box-readonly',
            title: 'ID',
            groupId: 1,
            size: [1, 1],
            fieldNameText: 'kod_emp',
        },
        {
            fieldType: 'ai-form-lookup',
            title: 'Состояние',
            groupId: 1,
            size: [1, 5],
            fieldNameId: 'pr_active',
            fieldNameText: 'status_name',
            extParams: {
                displayExpr: 'name',
                valueExpr: 'pr_active',
                dictionaryRoutePath: 'counteragent./customer/dict/status/get',
            },
        },
        {
            fieldType: 'ai-form-lookup',
            title: 'Функция',
            groupId: 1,
            size: [1, 3],
            fieldNameId: 'kod_dolzhfun',
            fieldNameText: 'name_fun',
            extParams: {
                displayExpr: 'name_fun',
                valueExpr: 'kod_dolzhfun',
                dictionaryRoutePath: 'counteragent./customer/dict/dolzhfun/get',
            },
        },
        {
            fieldType: 'ai-form-lookup',
            title: 'Должность',
            groupId: 1,
            size: [1, 3],
            fieldNameId: 'kod_namedolzh',
            fieldNameText: 'dolzh_name',
            extParams: {
                displayExpr: 'name',
                valueExpr: 'kod_namedolzh',
                dictionaryRoutePath: 'counteragent./customer/dict/namedolzh/get',
            },
        },
        {
            fieldType: 'ai-form-text-box-readonly',
            title: 'Должность в род.падеже',
            groupId: 1,
            size: [1, 3],
            fieldNameText: 'namedolzh_r',
        },
        {
            fieldType: 'ai-form-text-box-readonly',
            title: 'Должность в дат.падеже',
            groupId: 1,
            size: [1, 3],
            fieldNameText: 'namedolzh_d',
        },
        {
            fieldType: 'ai-form-text-box',
            title: 'Табельный номер',
            groupId: 1,
            size: [1, 3],
            fieldNameText: 'tab_nomer',
        },
        {
            fieldType: 'ai-form-text-box',
            title: 'ИНН',
            groupId: 1,
            size: [1, 3],
            fieldNameText: 'inn',
        },
        {
            fieldType: 'ai-form-text-box',
            title: 'Фамилия',
            groupId: 1,
            size: [1, 6],
            fieldNameText: 'fio_f',
        },
        {
            fieldType: 'ai-form-text-box',
            title: 'Имя',
            groupId: 1,
            size: [1, 6],
            fieldNameText: 'fio_i',
        },
        {
            fieldType: 'ai-form-text-box',
            title: 'Отчество',
            groupId: 1,
            size: [1, 6],
            fieldNameText: 'fio_o',
        },
        {
            fieldType: 'ai-form-text-box-readonly',
            title: 'Ф.И.О.',
            groupId: 1,
            size: [1, 6],
            fieldNameText: 'fio',
        },
        {
            fieldType: 'ai-form-text-box',
            title: 'Ф.И.О. в род.падеже',
            groupId: 1,
            size: [1, 6],
            fieldNameText: 'fio_r',
        },
        {
            fieldType: 'ai-form-text-box',
            title: 'Ф.И.О. в дат.падеже',
            groupId: 1,
            size: [1, 6],
            fieldNameText: 'fio_d',
        },
        {
            fieldType: 'ai-form-text-box',
            title: 'Телефон',
            groupId: 1,
            size: [1, 3],
            fieldNameText: 'tel',
        },
        {
            fieldType: 'ai-form-text-box',
            title: 'Мобильный телефон',
            groupId: 1,
            size: [1, 3],
            fieldNameText: 'm_tel',
        },
        {
            fieldType: 'ai-form-text-box',
            title: 'Прочие телефоны',
            groupId: 1,
            size: [1, 6],
            fieldNameText: 'p_tel',
        },
        {
            fieldType: 'ai-form-text-box',
            title: 'Факс',
            groupId: 1,
            size: [1, 3],
            fieldNameText: 'fax',
        },
        {
            fieldType: 'ai-form-text-box',
            title: 'Адрес электронной почты',
            groupId: 1,
            size: [1, 3],
            fieldNameText: 'e_mail',
        },
        {
            fieldType: 'ai-form-text-box',
            title: 'Местоположение',
            groupId: 1,
            size: [1, 6],
            fieldNameText: 'place',
        },
        {
            fieldType: 'ai-form-text-box',
            title: 'Примечание',
            groupId: 1,
            size: [1, 6],
            fieldNameText: 'remark',
        },
        {
            fieldType: 'ai-form-text-box',
            title: 'Номер и дата доверенности',
            groupId: 1,
            size: [1, 3],
            fieldNameText: 'num_dover',
        },
        {
            fieldType: 'ai-form-date-box',
            title: 'Дата окончания действия доверенности',
            groupId: 1,
            size: [1, 3],
            fieldNameText: 'dover_expire_date',
        },
        {
            fieldType: 'ai-form-text-box',
            title: 'Префикс СФ',
            groupId: 1,
            size: [1, 6],
            fieldNameText: 'pref',
        },
        {
            fieldType: 'ai-form-check-box',
            title: 'Съём показаний',
            groupId: 1,
            size: [1, 3],
            fieldNameText: 'pr_ctrl',
        },
        {
            fieldType: 'ai-form-check-box',
            title: 'Право подписания договора',
            groupId: 1,
            size: [1, 3],
            fieldNameText: 'pr_dog_podp',
        },
    ],
};

</script>

